import React, { useEffect } from "react";
import "./index.66c4e38f.css";
import "./index.0e7756c7.css";
import { useState } from "react";
import EmailDocumentsDialog from "../orderinvoices/EmailDocumentsDialog";
import CustomPopupDialog from "../../components/global/CustomPopupDialog/CustomPopupDialog";
import moment from "moment";
import { setValidationCss } from "../../common/utils";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { OrderSummarySchema } from "../../components/schemas/OrderSummarySchema";
import { useTranslation } from "react-i18next";
import {
  MergeDocumentExpress,
  ReadDocumentAsStream,
  SendEmailExpress,
  uploadDocumentSelector,
} from "../../features/uploadDocument/uploadDocumentSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GetDocStoreDetails, orderSummarySelector } from "../../features/ordersSummary/orderSummarySlice";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { Link, useParams } from "react-router-dom";
import AcceptPickupPopup from "./AcceptPickupPopup";
import Tooltip from "../../components/global/Tooltip/Tooltip";
import { GetFileSummaryExpress, orderSliceSelector } from "../../features/orders/orderSlice";
import { languageSelector } from "../../features/language/languageSlice";
const ReadyforPickupDocuments = ({
  // docresponse,
  setViewDocs,
  // filenumber,
  // fileID,
  //viewFile,
  // userLogin,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    setFocus,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(OrderSummarySchema),
    mode: "onBlur",
  });

  const { id } = useParams();
  const fileID = id - 100000;
  const filenumber = id;
  const [docresponse, setdocresponse] = useState(null);
  const { userLogin } = useSelector(authLoginSelector);
  const { DocStoreDetails } = useSelector(orderSummarySelector);
  const ordersummaryloading = useSelector((state) => state.orderSummary.loading);
  const lang = useSelector(languageSelector);

  useEffect(() => {
    if ((!docresponse || docresponse === null) && fileID !== null) {
      dispatch(GetDocStoreDetails(fileID, userLogin?.userId));
    }
  }, [docresponse, fileID, userLogin, DocStoreDetails]);

  watch(DocStoreDetails);
  useEffect(() => {
    setdocresponse(DocStoreDetails?.DocStore)
  }, [DocStoreDetails]);

  const { t } = useTranslation();
  const [hiddenMergeColumn, sethiddenMergeColumn] = useState(true);
  const [EmailDocuments, setEmailDocuments] = useState(false);
  const [isMergeSelected, setisMergeSelected] = useState(0);
  const [docErrorMessageMerge, setdocErrorMessageMerge] = useState("");
  const [isCheck, setIsCheck] = useState([]);
  const dispatch = useDispatch();
  const { loading } = useSelector(uploadDocumentSelector);
  const [isEmailSelected, setisEmailSelected] = useState(0);
  const [isEmailValid, setEmailValid] = useState(true);
  const [emailList, setEmailList] = useState([
    { email: userLogin?.email, username: userLogin?.loginName },
  ]);
  const [isemailIDSelected, setisemailIDSelected] = useState(false);
  const [isDocSelected, setisDocSelected] = useState(false);
  const [docErrorMessage, setdocErrorMessage] = useState("");


  const viewFile = (storageFileID) => {
    dispatch(ReadDocumentAsStream(storageFileID, userLogin?.userId, 1));
  };


  const { fileSummaryDetails } = useSelector(orderSliceSelector);

  useEffect(() => {
    let emails = [];
    if (fileSummaryDetails === null) {
      dispatch(GetFileSummaryExpress(fileID, userLogin?.userId));
    } else {
      if (
        fileSummaryDetails?.lawyerEmail !== null &&
        fileSummaryDetails?.lawyerEmail !== "" &&
        fileSummaryDetails?.lawyerName !== ""
      ) {
        emails.push({ email: fileSummaryDetails?.lawyerEmail, username: fileSummaryDetails?.lawyerName });
      }
      if (
        fileSummaryDetails?.orderingLawyerEmail !== null &&
        fileSummaryDetails?.orderingLawyerEmail !== "" &&
        fileSummaryDetails?.orderingLawyerName !== "" &&
        fileSummaryDetails?.lawyerEmail !== fileSummaryDetails?.orderingLawyerEmail
      ) {

        emails.push({ email: fileSummaryDetails?.orderingLawyerEmail, username: fileSummaryDetails?.orderingLawyerName });

      }
      if (
        fileSummaryDetails?.assistantEmail !== null &&
        fileSummaryDetails?.assistantEmail !== "" &&
        fileSummaryDetails?.assistantName !== ""
      ) {

        emails.push({ email: fileSummaryDetails?.assistantEmail, username: fileSummaryDetails?.assistantName });

      }
      setEmailList(emails);
    }

  }, [fileSummaryDetails]);

  //repeating code from orderSummaryDocstoreform, we can avoid it amking common functions
  const DocStoreformSubmit = async (data) => {
    if (!data.DocStoreIDArray || data.DocStoreIDArray.length < 2) {
      setisMergeSelected(1);
      setdocErrorMessageMerge("Select at least 2 documents");
      return;
    }

    let request = {
      FileDetails: data.DocStoreIDArray,
      FileID: fileID,
      FileNumber: filenumber,
      UserID: userLogin.userId,
      DocName: data.DocumentPackage,
    };
    setValue("DocumentPackage", "");
    dispatch(MergeDocumentExpress(request));
    setisMergeSelected(0);
    MoveUP();
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item != id));
    }
    if (isCheck.length > 1) setdocErrorMessageMerge("");
  };

  const [isHeaderChecked, setIsHeaderChecked] = useState(false);


  const handleHeaderCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    const newCheckedItems = [];
    docresponse?.map((item, index) => {
      newCheckedItems.push(item.storageFileID);
    })
    if (isChecked)
      setIsCheck(newCheckedItems);
    else
      setIsCheck([]);
    setIsHeaderChecked(isChecked);
  };


  function emailValidation(val) {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (regex.test(val) === false || val === "") {
      setEmailValid(false);
      //setValue(isEmailValid, false);
      return false;
    }
    setEmailValid(true);
    //setValue(isEmailValid, true);
    return true;
  }

  const sendEmailClick = (e) => {
    let val = getValues();
    if (
      (!Array.isArray(val.emailArray) && val.emailArray === false) ||
      (Array.isArray(val.emailArray) && val.emailArray.length === 0)
    ) {
      setisemailIDSelected(true);

      // setdocErrorMessage(t("selectEmailErrorMsg"));
    } else {
      setisemailIDSelected(false);
      setdocErrorMessage("");
      if (val.DocStoreIDArray.length === 0 || !val.DocStoreIDArray) {
        setisDocSelected(true);
        setdocErrorMessage("Select at least 1 document");
      } else {
        setdocErrorMessage("");
        setisDocSelected(false);

        let request = {
          UserID: userLogin.userId,
          Emailvalue: Array?.isArray(val?.emailArray) ? val?.emailArray : Array(val?.emailArray),
          FileID: fileID,
          EmailDoclist: Array?.isArray(val?.DocStoreIDArray) ? val?.DocStoreIDArray : Array(val?.DocStoreIDArray),
        };
        setValue(`email`, "");
        dispatch(SendEmailExpress(request, { toast }));
        setisEmailSelected(0);
      }
    }
    MoveUP();
  };

  let emailIDs = [];

  const addEmailClick = (e) => {
    let val = getValues();
    let err = errors;
    emailList.map((item, index) => {
      return emailIDs.push({ email: item.email, username: item.username });
    });
    if (emailValidation(val.email)) {
      emailIDs.push({ email: val.email, username: val.email });
    }
    setEmailList(emailIDs);
    setValue(`email`, "");
  };


  const [AcceptPopupDailog, setAcceptPopupDailog] = useState(false);
  function MoveUP() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  //repeating code from orderSummaryDocstoreform, we can avoid it amking common functions

  return (
    <>
      <div>
        <div className="!w-[1340px] flex">
          <Link to="/orderstatus?tab=2">
            <button
              onClick={() => setViewDocs(null)}
              className="cursor-pointer h-fit w-fit"
              aria-label="Orders page return button"
            >
              <div className="flex items-center justify-start mr-[4px]">
                <p className="mr-[4px] text-secondary-blue-link">
                  {t("Ready")}

                </p>
                <svg width="20" height="20" fill="none">
                  <path
                    d="m7.308 15.922 5.384-5.923-5.384-5.923"
                    stroke="#A09F9F"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </button>
          </Link>
          <p className="font-bold mb-[40px]">
            <span>{t("OrdernumHeader")}</span>  {" "} <span>{filenumber}</span> {t("Documents")}</p>
          <div className="ml-auto mr-0" >
            <div style={{ display: "inline-block" }} className="w-max">
              <button
                id="confirm-pickup"
                className="!hover:bg-[#FAE094] border-box-stroke btn__secondary font-[600] font-open-sans pt-2 py-2 pl-4 text-[16px] text-box-stroke  h-full w-max btn__secondary-active"
                //disabled={selectedReadyForpickupOrders?.length > 0 ? "" : "true"}
                onClick={() => setAcceptPopupDailog(true)}
              >
                <div>
                  {t("AcceptPickup")}
                  <Tooltip text={t("AcceptpickupTooltip")} />
                </div>
              </button>
              {AcceptPopupDailog && <AcceptPickupPopup setAcceptPopupDailog={setAcceptPopupDailog}
                selectedReadyForpickupOrders={[]}
                isRedirectTopolicyPickup={true}
                filenumber={filenumber}
              // setSelectedRows={setSelectedRows} 
              // reloadTabs={reloadTabs}
              />}
            </div>
            <div style={{ display: "inline-block" }}>
              <Link to="/orderstatus?tab=2">
                <button
                  className="flex focus:bg-[#F8F8F8] font-semibold h-[40px] hover:bg-[#F8F8F8] outline-neutrals-black ml-10 py-2 rounded-sm"
                  onClick={() => setViewDocs(null)}
                >
                  <div className="flex items-center justify-center mr-[2px]">
                    <svg
                      role="none"
                      aria-hidden="true"
                      width="20"
                      height="20"
                      fill="none"
                    >
                      <path
                        d="m11.692 4.078-5.384 5.923 5.384 5.923"
                        stroke="#000"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  {t('Back')}
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div
          className="border border-[#A09F9F] rounded-[3px] mb-[48px]"
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "20%",
          }}
        >
          <div className="!h-[60px] bg-white flex mb-[48px] mt-4">
            <div className="p-6">
              <p className="!font-bold !font-montserrat text-[22px]">
                {t("OrdernumHeader")} {filenumber}
              </p>
              <p className="text-[16px]">{t("selectDocuments")}</p>
            </div>
            <div className="!h-auto flex items-center ml-auto mr-6">
              <button
                id="merge-selected"
                className="!h-auto bg-transparent border border-neutrals-black btn__secondary mr-[16px] pl-2 pr-4 py-2 w-max"
                onClick={() => {
                  sethiddenMergeColumn(false);
                  setisMergeSelected(1);
                }}
                disabled={isCheck?.length >= 2 ? false : true}
              >
                <svg
                  className="float-left mr-2"
                  width="20"
                  height="20"
                  fill="none"
                  role="none"
                  aria-hidden="true"
                >
                  <path
                    d="M11.667 1.666H5.001a1.667 1.667 0 0 0-1.667 1.667v13.333a1.667 1.667 0 0 0 1.667 1.667h10a1.667 1.667 0 0 0 1.666-1.667v-10l-5-5Z"
                    stroke="#000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.666 1.666v5h5M13.333 10.834H6.666M13.333 14.166H6.666M8.333 7.5H6.666"
                    stroke="#000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {t("mergedoc")}
              </button>
              <button
                id="email-selected"
                className="!h-auto bg-transparent border border-neutrals-black btn__secondary pl-2 pr-4 py-2 w-max"
                onClick={() => {
                  setEmailDocuments(true);
                  sethiddenMergeColumn(true);
                  setisEmailSelected(1);
                }}
                disabled={isCheck?.length >= 1 ? false : true}
              >
                <svg
                  className="float-left mr-2"
                  width="20"
                  height="20"
                  fill="none"
                  role="none"
                  aria-hidden="true"
                >
                  <path
                    d="M3.6 4h12.8c.88 0 1.6.675 1.6 1.5v9c0 .825-.72 1.5-1.6 1.5H3.6c-.88 0-1.6-.675-1.6-1.5v-9C2 4.675 2.72 4 3.6 4Z"
                    stroke="#000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="m17 5-7 6-7-6"
                    stroke="#000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {t("EmailDoc")}
              </button>
            </div>
          </div>
          <div className="bg-[#FFF6DF] border-[#A09F9F] flex font-[600] pl-[32px] pr-[32px] rounded-t-[2px] text-[14px]">
            <div
              className={
                hiddenMergeColumn
                  ? "hidden"
                  : "" + "merged-document mr-[24px] py-[14px]"
              }
            >
              <p>{t("MergeOrder")}</p>
            </div>
            <div className="hidden mr-[24px] py-[14px] select-emails">
              <p>{t("MergeOrder")}</p>
            </div>
            <div className="mr-[24px] py-[14px]">
              <input
                id="order-checkall"
                aria-label="All orders checkbox"
                className="custom__checkbox mr-4 self-center"
                type="checkbox"
                checked={isHeaderChecked}
                onChange={handleHeaderCheckboxChange}
              />
            </div>
            <div className="mr-[28px] py-[14px] text-left w-100">
              {t("docname")}
            </div>
            <div className="mr-[70px] py-[14px] text-left w-100">
              {t("Doctype")}
            </div>
            <div className="mr-[20px] py-[14px] text-left w-100">{t("IssueDate")}</div>
          </div>
          <div id="table-content">
            {docresponse?.map((item, index) => {
              return (
                <div className="!h-[60px] flex font-[400] hover:bg-accordion-bg order-content pl-[32px] pr-[32px] text-[14px]">
                  {!hiddenMergeColumn && (
                    <div className="!font-bold mr-[40px] pb-[16px] pt-[24px] text-[#526D7D] text-center w-[70px]">
                      {index + 1}
                    </div>
                  )}
                  <div
                    id="checkbox-container"
                    className="mr-[24px] pb-[16px] pt-[24px] text-left"
                  >
                    <input
                      className="custom__checkbox mr-4 self-center"
                      type="checkbox"
                      id={item?.storageFileID}
                      name="DocStoreIDArray"
                      value={item?.storageFileID}
                      storeid={item?.storageFileID}
                      checked={isCheck.toString().includes(item?.storageFileID)}
                      {...register("DocStoreIDArray")}
                      onChange={handleClick}
                    />
                  </div>

                  <a
                    className="!font-bold mr-[40px] pb-[16px] pt-[24px] text-[#526D7D] text-left underline w-100"
                    onClick={() => {
                      viewFile(item?.storageFileID);
                    }}
                  >
                    {item?.filename}
                  </a>

                  <div className="mr-[20px] pb-[16px] pt-[24px] text-left w-100">
                    {lang?.value === "fr" ? item?.documentTypeFr : item?.documentType}
                  </div>
                  <div className="mr-[20px] pb-[16px] pt-[24px] text-left w-100">
                    {moment(item?.documentSourceDate).format(
                      "DD/MM/yyyy hh:mm:ss A"
                    )}
                  </div>
                </div>
              );
            })}
            <div className="px-[32px] pt-6">
              <hr className="border-line-thick w-full" />
            </div>
          </div>
          {!hiddenMergeColumn && (
            <div
              className={
                isMergeSelected === 1
                  ? "mb-6 merged-document ml-8"
                  : "hidden mb-6 merged-document ml-8"
              }
            >
              <p className="font-semibold mb-2 mt-4">{t("docname")}</p>
              <div className="flex flex-flow">
                <div className="mr-4 w-[388px]">
                  <input
                    {...register("DocumentPackage")}
                    name="DocumentPackage"
                    placeholder={
                      errors.DocumentPackage
                        ? t("RequiredFieldErrMsg")
                        : t("DocumentPackage")
                    }
                    type="text"
                    style={setValidationCss(errors.DocumentPackage)}
                  />
                </div>
                <button
                  onClick={handleSubmit(DocStoreformSubmit)}
                  className="btn__primary mr-1 px-4 py-2"
                >
                  {t("Merge")}
                </button>
                <button
                  className="btn__tertiary px-4 py-2 text-secondary-red"
                  onClick={() => sethiddenMergeColumn(true)}
                >
                  {t("Cancel")}
                </button>
              </div>
              <span className="font-semibold text-secondary-red">
                {isMergeSelected && docErrorMessageMerge}
              </span>
            </div>
          )}
          {EmailDocuments && hiddenMergeColumn && (
            <div >
              <EmailDocumentsDialog
                setEmailDocuments={setEmailDocuments}
                isEmailSelected={isEmailSelected}
                setisEmailSelected={setisEmailSelected}
                setValidationCss={setValidationCss}
                register={register}
                addEmailClick={addEmailClick}
                isEmailValid={isEmailValid}
                setEmailValid={setEmailValid}
                emailList={emailList}
                setEmailList={setEmailList}
                isemailIDSelected={isemailIDSelected}
                setisemailIDSelected={setisemailIDSelected}
                isDocSelected={isDocSelected}
                setisDocSelected={setisDocSelected}
                docErrorMessage={docErrorMessage}
                setdocErrorMessage={setdocErrorMessage}
                sendEmailClick={sendEmailClick}
                t={t}
                errors={errors}
                handleClick={handleClick}
                ToastContainer={ToastContainer}
              />
            </div>
          )}
        </div>
      </div>
      {loading || ordersummaryloading ? <Loader /> : ""}
    </>
  );
};

export default ReadyforPickupDocuments;
